module.exports = __webpack_public_path__ + "static/media/loading.a1cd24dd.gif";